var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"navbar-wrapper",attrs:{"slot":"brand"},slot:"brand"},[(_vm.title)?_c('a',{staticClass:"navbar-brand",attrs:{"href":"#"}},[_vm._v(_vm._s(_vm.title))]):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }